import React from "react";

import { useTranslation } from "react-i18next";

import LoadErrorAlert from "../LoadErrorAlert";
import AppsRegenerationNotice from "./AppsRegenerationNotice";
import FontFaceStyles from "./FontFaceStyles";
import FontRoleFields from "./FontRoleFields";
import OrganizationFontList from "./OrganizationFontList";

import type { JSX } from "react";

import type { FontFamily, ProjectFontRoles } from "@/src/api/StylesAPI.types";

interface FontsPanelProps {
  familyList: FontFamily[];
  roles: ProjectFontRoles;
  isLoading: boolean;
  isDisabled: boolean;
  isFamilyListError: boolean;
  onRetryFamilyList: () => void;
  onFontDeleted: (fontUuid: string) => void;
}

function FontsPanel({
  familyList,
  roles,
  isLoading,
  isDisabled,
  isFamilyListError,
  onRetryFamilyList,
  onFontDeleted,
}: FontsPanelProps): JSX.Element {
  const { t } = useTranslation("editor-appearance");

  return (
    <div className="flex flex-col gap-[22px]">
      {isFamilyListError ? (
        <LoadErrorAlert
          message={t("loadFontsError")}
          onRetry={onRetryFamilyList}
        />
      ) : null}
      <FontFaceStyles familyList={familyList} />
      <FontRoleFields
        familyList={familyList}
        isDisabled={isDisabled}
        isLoading={isLoading}
        roles={roles}
      />
      <AppsRegenerationNotice familyList={familyList} roles={roles} />
      <OrganizationFontList
        familyList={familyList}
        isLoading={isLoading}
        onDeleted={onFontDeleted}
      />
    </div>
  );
}

export default FontsPanel;
